import { Grid, Skeleton } from '@mui/material';

const RecurringIntervalPickerSkeleton = () => {
  return (
    <Grid container gap={1}>
      <Grid container gap={6}>
        <Skeleton width={18} />
        <Skeleton width={18} />
        <Skeleton width={18} />
        <Skeleton width={18} />
        <Skeleton width={18} />
        <Skeleton width={18} />
        <Skeleton width={18} />
      </Grid>
      <Skeleton width={800} />
    </Grid>
  );
};

export default RecurringIntervalPickerSkeleton;
